import { inject, Injectable } from '@angular/core';
import { SadmEntityDisplay } from '@modules/sadm/models/sadm-entity-display';
import { Store } from '@ngrx/store';
import { SadmClient } from '@pixacare/dtos';
import { sadmActions } from '@shared/store/sadm/sadm.actions';
import {
  selectIsPatientSadmStateLoaded,
  selectPatientSadmEntities,
  selectSadmClients,
} from '@shared/store/sadm/sadm.selectors';
import { map, Observable, shareReplay, switchMap } from 'rxjs';
import { PatientService } from '../patient/patient.service';

@Injectable()
export class PatientAnalysesService {
  private readonly store = inject(Store);
  private readonly patientService = inject(PatientService);

  readonly sadmClients$: Observable<SadmClient[]> = this.store.select(selectSadmClients);

  readonly sadmEntities$: Observable<SadmEntityDisplay[]> = this.patientService.getParams().pipe(
    switchMap(({ clientCode, patientId, isArchived }) => {
      this.store.dispatch(sadmActions.getSadmEntities({ clientCode, patientId, isArchived }));
      return this.store.select(selectPatientSadmEntities(clientCode, patientId, isArchived));
    }),
    map((entities) => [...entities].sort((first, second) => second.createdOn.getTime() - first.createdOn.getTime())),
    shareReplay({ bufferSize: 1, refCount: true }),
  );

  readonly isDataLoaded$: Observable<boolean> = this.patientService
    .getParams()
    .pipe(
      switchMap(({ clientCode, patientId }) =>
        this.store.select(selectIsPatientSadmStateLoaded(clientCode, patientId)),
      ),
    );
}
